<div class="page-wrapper">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <button class="scroll-top scroll-to-target" style="background-color: #4C656A;" data-target="html">
        <span class="fa fa-angle-up"></span>
    </button>
</div>